<!--中心简介-->
<template>
  <div id="itroIndex">
      <bread :content="breadContent"></bread>
      <p class="Page-title">中心简介</p>
      <el-divider></el-divider>
      <!-- <p class="mes-font" v-html="word"></p> -->
      <Article :html="word" margin="0 44px 0 0" class="mes-font"></Article>

  </div>
</template>

<script>
import bread from '@/components/bread'
import Api from '@/network.js'
import Article from '@/components/article'

export default {
  name:'itroIndex',
  data() {
    return {
      word:'',
      breadContent:[
        {text:'首页',routerName:'index'},
        {text:'中心概况',routerName:'introduce'},
        {text:'中心简介',routerName:'introduce'},
      ]
    };
  },
  async beforeRouteEnter(to,from,next){
    let res=await Api.introduce.getIntroduce();
    next(vm=>{
      vm.word=res;
    })
  },
  components: {
    bread,
    Article
  }
};
</script>
  
<style lang="scss" scoped>
#itroIndex {
 display: block;
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
  .mes-font {
    font-size: 18px;
    text-indent: 36px;
    line-height: 32px;
    margin-bottom: 18px;
    text-align: justify;
  }
}
</style>
